export const Data = [
  {
    type: "zh",
    imgBoxUrl:"https://www.victrum.com/image/tp/解决方案banner.png",
    numList : [
      {
        num : "1",
        tital : "对医院",
        path: "dyy"
      },
      {
        num : "2",
        tital : "对医生",
        path: "dys"
      },{
        num : "3",
        tital : "对患者",
        path: "dhz"
      }
    ],
    itemData:[{
      num : "1",
      path: "dyy",
      showData:false,
      img1:"https://www.victrum.com/image/nr/jjfa/1.jpg",
      img2:"https://www.victrum.com/image/nr/jjfa/2.jpg",
      img3:"https://www.victrum.com/image/nr/jjfa/3.jpg",
      text1:"舒适化诊疗中心",
      text2:"提升医院/科室竞争力：打造激光治疗特色，使医院/科室在专业领域更具差异化优势，树立技术领先、学术领先的形象，提升医院/科室的学术地位。\n" +
        "增加经济效益：口腔激光治疗具备专门的收费条目，且由于患者治疗接受度高，能够为医院/科室带来更多的经济收入。\n" +
        "促进科研与教学：为开展相关的科研项目提供了更多的研究方向和实践基础，产出更多的科研成果。同时也有利于教学工作的开展，培养更多优秀的人才。\n" +
        "优化治疗效果：口腔激光治疗的精准性和有效性有助于提高科室对各类口腔疾病的治疗水平，如激光辅助的口腔种植、牙周病治疗、根管治疗等为患者提供更优质的医疗服务，从而增加患者对医院/科室的信任和认可。"
    },
      {
        num : "2",
        path: "dys",
        showData:false,
        img1:"https://www.victrum.com/image/nr/jjfa/1.jpg",
        img2:"https://www.victrum.com/image/nr/jjfa/2.jpg",
        img3:"https://www.victrum.com/image/nr/jjfa/3.jpg",
        text1:"舒适化诊疗中心",
        text2:"提升专业技能：掌握口腔激光技术，丰富了治疗手段，拓宽了医生的专业知识和技能领域，使其在专业领域更具竞争力。\n" +
          "增加发展机会：在学术交流和研究方面，口腔激光治疗是一个新兴领域。通过参与相关研究和发表学术成果，能够获得更多的晋升以及学术发展机会。\n" +
          "提高治疗效果：激光治疗的精准性和有效性有助于医生更好地处理病例，获得更满意的治疗结果。同时相比传统方法，激光治疗有时能更快速地完成部分操作，提高了医生的工作效率。\n" +
          "更安全的工作环境：铒激光相对传统涡轮手机能够减少98%的气溶胶产生，使医生的工作环境更加友好和安全。\n" +
          "增强患者满意度：良好的治疗效果和患者体验能够显著提高患者对医生的满意度和信任度，有助于建立良好的医患关系，提升医生的声誉。"
      },
      {
        num : "3",
        path: "dhz",
        showData:false,
        img1:"https://www.victrum.com/image/nr/jjfa/1.jpg",
        img2:"https://www.victrum.com/image/nr/jjfa/2.jpg",
        img3:"https://www.victrum.com/image/nr/jjfa/3.jpg",
        text1:"舒适化诊疗中心",
        text2:"更舒适的体验：相较于传统治疗方法可能引起的强烈疼痛和不适，口腔激光治疗通常能大幅减轻患者在治疗过程中的疼痛感，让患者更容易接受治疗。\n" +
          "减少肿胀和疼痛：在手术或治疗过程中，激光能够烧灼小血管、淋巴管和暴露的神经末梢，从而降低术后肿胀和疼痛的程度。意味着患者术后的恢复更加顺利，不适感也相对较少。\n" +
          "缩短康复周期：由于激光对组织的损伤较小，能够刺激细胞的修复和再生，患者可以更快地恢复正常的口腔功能，减少因治疗对生活和工作的影响。\n" +
          "降低感染几率：激光的杀菌作用有助于清除病原体，创造一个相对清洁的治疗环境，从而显著降低感染的风险，并能够减少抗生素的使用。\n" +
          "改善美观效果：在一些涉及口腔美容的治疗中，如牙龈修整、牙龈脱色等，激光能够提供更精细、自然的效果，满足患者对美观的需求。"
      }
    ]
  },
  {
    type: "en",
    imgBoxUrl:"https://www.victrum.com/image/tp/解决方案banner.png",
    numList : [
      {
        num : "1",
        tital : "For Hospitals/Departments",
        path: "dyy"
      },
      {
        num : "2",
        tital : "For Doctors",
        path: "dys"
      },{
        num : "3",
        tital : "For Patients",
        path: "dhz"
      }
    ],
    itemData:[{
      num : "1",
      path: "dyy",
      showData:false,
      img1:"https://www.victrum.com/image/nr/jjfa/1.jpg",
      img2:"https://www.victrum.com/image/nr/jjfa/2.jpg",
      img3:"https://www.victrum.com/image/nr/jjfa/3.jpg",
      text1:"Comfortable Diagnosis and Treatment Center",
      text2:"Enhancing Competitiveness: Establishing a specialty in laser treatment can help hospitals or departments differentiate themselves in their field, creating a reputation for being technologically and academically advanced. This not only enhances the hospital's or department’s image but also elevates its academic standing.\n" +
        "Increasing Economic Benefits: Dental laser treatment has specific billing codes, and due to the high patient acceptance of such treatments, hospitals and departments can generate increased revenue.\n" +
        "Promoting Research and Education: Laser treatment provides numerous opportunities for scientific research and practical application, laying the foundation for more innovative research projects and outcomes. It also supports educational efforts by providing advanced technology for training future professionals.\n" +
        "Optimizing Treatment Outcomes: The precision and effectiveness of dental laser treatments improve the department’s capability to treat a variety of oral diseases. Procedures such as laser-assisted dental implants, periodontal disease treatment, and root canal therapy provide higher-quality care, boosting patient satisfaction and trust in the hospital or department."
    },
      {
        num : "2",
        path: "dys",
        showData:false,
        img1:"https://www.victrum.com/image/nr/jjfa/1.jpg",
        img2:"https://www.victrum.com/image/nr/jjfa/2.jpg",
        img3:"https://www.victrum.com/image/nr/jjfa/3.jpg",
        text1:"Comfortable Diagnosis and Treatment Center",
        text2:"Enhancing Professional Skills: Mastering dental laser technology expands the range of treatment options available to doctors, enriching their professional knowledge and skill set. This makes them more competitive within their field.\n" +
          "Increasing Career Opportunities: Dental laser treatment is an emerging area in both academic and clinical research. By engaging in related studies and publishing research findings, doctors can gain more opportunities for career advancement and academic recognition.\n" +
          "Improving Treatment Outcomes: The precision and effectiveness of laser treatments enable doctors to achieve better clinical results. In some cases, laser procedures can be performed more efficiently compared to traditional methods, increasing overall productivity.\n" +
          "Creating a Safer Work Environment: Er:YAG lasers significantly reduce aerosol production by up to 98% compared to traditional dental turbines, making the working environment safer and more conducive for doctors.\n" +
          "Boosting Patient Satisfaction: The superior treatment outcomes and enhanced patient experience provided by laser technology increase patient satisfaction and trust, helping doctors build stronger patient relationships and improve their professional reputation."
      },
      {
        num : "3",
        path: "dhz",
        showData:false,
        img1:"https://www.victrum.com/image/nr/jjfa/1.jpg",
        img2:"https://www.victrum.com/image/nr/jjfa/2.jpg",
        img3:"https://www.victrum.com/image/nr/jjfa/3.jpg",
        text1:"Comfortable Diagnosis and Treatment Center",
        text2:"More Comfortable Experience: Compared to traditional treatment methods that may cause significant pain and discomfort, dental laser therapy often greatly reduces pain during the procedure, making it easier for patients to accept and undergo treatment.\n" +
          "Reduced Swelling and Pain: During surgery or treatment, lasers can cauterize small blood vessels, lymphatic vessels, and exposed nerve endings, thereby minimizing post-operative swelling and pain. This means smoother recovery for patients with less discomfort after treatment.\n" +
          "Faster Recovery Time: Since lasers cause minimal tissue damage and promote cellular repair and regeneration, patients can return to normal oral function more quickly, reducing the impact of treatment on daily life and work.\n" +
          "Lower Risk of Infection: The sterilizing effect of the laser helps eliminate pathogens, creating a cleaner treatment environment. This significantly reduces the risk of infection and can decrease the need for antibiotics.\n" +
          "Enhanced Aesthetic Results: In procedures involving cosmetic dental treatments, such as gum contouring or depigmentation, lasers offer more precise and natural-looking results, satisfying patients’ aesthetic expectations."
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/components/js/companyProfile.js